import { NAV_PATHS } from '@modules/common/constants';
import { useDashboardStore } from '@modules/dashboard/store/useDashboardStore';
import { Stack } from '@mui/material';
import { Status } from 'generated/graphql';
import { matchPath, useLocation } from 'react-router-dom';
import { DashboardShareButton } from '../DashboardShareButton';
import { DashboardSubscribeV3 } from '../DashboardSubscribeV3';
import { RequestDashboardAccess } from '../RequestDashboardAccess';
import { DashboardHeaderAddAnalysisButton } from './DashboardHeaderAddAnalysisButton';
import { DashboardHeaderCopyLinkButton } from './DashboardHeaderCopyLinkButton';
import { DashboardHeaderMenu } from './DashboardHeaderMenu';
import { UnarchiveDashboardButton } from './UnarchiveDashboardButton';

export const DashboardHeaderActions = () => {
  const dashboard = useDashboardStore(({ dashboard }) => dashboard);
  const location = useLocation();
  const isNewDashboardPage = matchPath(
    `/${NAV_PATHS.NEW_DASHBOARD}`,
    location.pathname,
  );

  if (dashboard?.status === Status.Archived) {
    return <UnarchiveDashboardButton />;
  }

  if (!dashboard || (!dashboard.id && !isNewDashboardPage)) {
    return null;
  }

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <DashboardSubscribeV3 />
      <DashboardShareButton />
      <DashboardHeaderAddAnalysisButton />
      <DashboardHeaderCopyLinkButton />
      <RequestDashboardAccess />
      <DashboardHeaderMenu />
    </Stack>
  );
};
